<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputPassword4">Driver</label>
    <select class='form-control' [class.is-invalid]='this.driverHours.driverId === -1' (change)='this.driverHours.driverId = +$event.target.value; this.driverHours.driver.id = this.driverHours.driverId'>
      <option value='-1'>Select a driver</option>
      @for (item of this.drivers; track item) {
        <option [value]='item.id' [selected]='this.driverHours.driverId === item.id'>{{ item.firstName }} {{ item.lastName }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Date</label>
    <input type="date" name='name' [(ngModel)]='this.driverHours.date' [class.is-invalid]='!this.driverHours.date' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Start Time</label>
    <input (keyup)='updateTotalHours()' type="time" name='name' [(ngModel)]='this.driverHours.startTime' [class.is-invalid]='!this.driverHours.startTime' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">End Time</label>
    <input (keyup)='updateTotalHours()' type="time" name='registration' [(ngModel)]='this.driverHours.endTime' [class.is-invalid]='!this.driverHours.endTime'  class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Lunch Break</label>
    <input (keyup)='updateTotalHours()'type="number" name='vinNumber' [(ngModel)]='this.driverHours.lunchBreak' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Chargeable Hours</label>
    <input type="number" name='make' [(ngModel)]='this.driverHours.chargeableHours' [class.is-invalid]='!this.driverHours.endTime'  class="form-control" id="inputPassword4">
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label for="inputPassword4">Notes</label>
    <textarea name='notes' [(ngModel)]='this.driverHours.notes' class="form-control"></textarea>
  </div>
</div>
